import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Box, Switch, Stack, Typography } from '@mui/material';
import Editor from '@monaco-editor/react';

const MarkdownRenderer = ({
  children,
  html,
  content,
  contentType,
  defaultView = 'rendered',
  showToggle = false,
  label,
  height,
  ...props
}) => {
  const [viewMode, setViewMode] = useState(defaultView);
  const contentToRender = content || children;
  const isHtml = html || contentType === 'html';
  const isRendered = viewMode === 'rendered';

  const handleToggle = (event) => {
    setViewMode(event.target.checked ? 'rendered' : 'code');
  };

  const renderContent = () => {
    if (!isRendered) {
      return (
        <Box sx={{ height: height || '100%', width: '100%', ...props.sx }} {...props}>
          <Editor
            height="100%"
            defaultLanguage={isHtml ? 'html' : 'markdown'}
            value={contentToRender}
            options={{
              readOnly: true,
              minimap: { enabled: false },
              wordWrap: 'on',
              scrollBeyondLastLine: false,
              padding: { top: 16, bottom: 16 }
            }}
          />
        </Box>
      );
    }
// ...

    if (isHtml) {
      return (
        <Box sx={{ height: height || '100%', width: '100%', ...props.sx }} {...props}>
          <iframe
            title="html-content"
            srcDoc={contentToRender}
            style={{ width: '100%', height: '100%', border: 'none' }}
            sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
          />
        </Box>
      );
    }

    return (
      <Box sx={{ height: height, overflow: 'auto', ...props.sx }} {...props}>
        <ReactMarkdown remarkPlugins={[remarkGfm]}>
          {contentToRender}
        </ReactMarkdown>
      </Box>
    );
  };

  return (
    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 1 }}>
      {showToggle && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', borderBottom: 1, borderColor: 'divider', pb: 1 }}>
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography variant="body2" color={!isRendered ? 'primary' : 'text.secondary'}>
              Code
            </Typography>
            <Switch
              checked={isRendered}
              onChange={handleToggle}
              size="small"
              inputProps={{ 'aria-label': 'view toggle' }}
            />
            <Typography variant="body2" color={isRendered ? 'primary' : 'text.secondary'}>
              Rendered
            </Typography>
          </Stack>
        </Box>
      )}
      {renderContent()}
    </Box>
  );
};

export default MarkdownRenderer;
